module.exports = __webpack_public_path__ + "b9df535c833790aff616a87f9689652a.svg";